/** FR-006a — cliente sin negocios asignados. */
export function SinNegocio() {
    return (
        <div className="mx-auto max-w-md space-y-2 py-16 text-center font-mono">
            <h2 className="text-sm font-semibold text-neutral-100">Sin negocios asignados</h2>
            <p className="text-xs text-neutral-500">
                Tu cuenta no tiene acceso a ningún negocio. Contacta con el administrador.
            </p>
        </div>
    )
}
